console.log("UI init", parent.document.URL);
document.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("showCart") && urlParams.get("showCart") === "true") {
    const cartElement = document.querySelector(
      ".icon-button-header-shopping-bag"
    );
    cartElement.click();
  }
  var routes = [
    "/pages/flag-maker",
    "/pages/user-reviews",
    "/pages/vexillology",
    "/pages/contact-about",
  ];
  if (checkSubPage(parent.document.URL, routes)) {
    console.log("UI init", parent.document.URL);
    removeSections();
  }

  const selectEl = document.querySelector("#option1"); // target your select

  if (selectEl) {
    const options = Array.from(selectEl.options);

    // Find the "Custom Shape And/Or Size" option
    const customOption = options.find(opt => opt.value === "Custom Shape And/Or Size");

    if (customOption) {
      // Remove it from current position
      selectEl.removeChild(customOption);

      // Append it as last option
      selectEl.appendChild(customOption);
    }
  }
});

function removeSections() {
  var mainElement = document.getElementById("main");
  var body = document.getElementsByTagName("body")[0];

  if (
    body.classList.contains("template-page") &&
    !body.classList.contains("flag__maker-page")
  ) {
    mainElement.childNodes.forEach((data) => {
      if (
        data.tagName == "SECTION" &&
        !data.classList.contains("page-section")
      ) {
        data.style.display = "none";
      }
    });
  }
}

function checkSubPage(parentURL, routesToCheck) {
  for (var i = 0; i < routesToCheck.length; i++) {
    if (parentURL.includes(routesToCheck[i])) {
      return true;
    }
  }
  return false;
}

// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

/* Iframe message listener */
window.addEventListener("message", (event) => {
  if (event.origin == "https://app.flagmaker-print.com") {
    let msg_data = event.data;

    switch (msg_data.type) {
      case "CART_ITEM":
        addToCart(msg_data.data);
        break;
      case "PAGE_NAV":
        if (msg_data.data) window.location.href = msg_data.data.path;
        break;
      default:
        break;
    }
  }
  if (event.data.data == "GET_RESOLUTION") {
    getResolution();
  }
  if (event.data.data == "FULL_SCREEN") {
    console.log(event);
    toggleFullScreen(event.data.isFull);
  }

   if (event.data.data && event.data.data.name=== "MOB_FULL_SCREEN") {
  console.log("Mobile full screen");
  mobileFullScreen(event.data.data);
  }
  
  if (event.data.data === "LOAD_MOB_FULL_SCREEN") 
  {
    mobileFullScreen();
  }
  

});



window.addEventListener("orientationchange", function () {


   if (window.orientation === 90) {
        // Reload the page
        console.log("This is the landscape mode");
        // window.location.href = "https://beta.flagmaker-print.com/";
        const templateIndex = document.querySelector('.template-index');

        console.log(" ****** templateIndex ******* ", templateIndex);

      } else {
        console.log("this is portrait mode");
            document.querySelector('.template-index').style.overflow = 'unset';

        
      }

})



function mobileFullScreen(data) {
  console.log("This is mobile full screen function");
  const element = document.querySelector('.custome__iframe');
  if (element) {
    var offsetTop = 100;
    console.log("Offset top of the element:", offsetTop);
    
    if (!isNaN(offsetTop)) {
      // window.scrollTo({
      //   top: offsetTop,
      //   behavior: 'smooth'
      // });
      
    } else {
      console.error("Offset top is not a number. Unable to scroll.");
    }
  } else {
    console.error("Element with ID 'fmp-beta-iframe' not found.");
  }

  if(data && data.trigger && data.trigger === "ENTER_FULLSCREEN") {
    // sendExitFullscreen("EXIT_FULLSCREEN");
       // document.querySelector('.template-index').style.overflow = 'hidden';
    
    
  } else {
    // sendExitFullscreen("ENTER_FULLSCREEN");
    // document.querySelector('.template-index').style.overflow = 'unset';
    
    
  }
}


// function sendExitFullscreen(trigger) {
//   console.log("sendExitFullScreen :");
//   const iframes = document.getElementsByTagName("iframe");

//   // Loop through each iframe element
//   for (var i = 0; i < iframes.length; i++) {
//     // Access each iframe element
//     var iframe = iframes[i];
//     console.log(iframe, "Iframe object");

//     // Check if the iframe has a contentWindow property
//     if (iframe.contentWindow) {
//       const exitText = "EXIT FULLSCREEN";
//       console.log("Exit Fullscreen");
      
//       // Post message to the iframe
//       iframe.contentWindow.postMessage({
//         event_id: "message",
//         data: trigger,
//         exitText: exitText
//       }, "*");
//     }
//   }
// }






/* Creating the function for getting the height and width */

function getResolution() {
  const container = document.getElementById("shopify-section-1596642949266");
  console.log("Container:", container);
  if (container) {
    const iframes = container.getElementsByTagName("iframe");
    console.log("iframe:", iframes);
    if (iframes.length > 0) {
      const iFrame = iframes[0];
      console.log(iFrame, "Iframe object");
      if (iFrame && iFrame.contentWindow) {
        const height = window.innerHeight;
        console.log("Height:", height);
        const width = window.innerWidth;
        console.log("Width:", width);
        iFrame.contentWindow.postMessage(
          {
            event_id: "message",
            data: "GET_RESOLUTION",
            width,
            height,
          },
          "*"
        );
      }
    }
  }
}

/*	
Custom Change - Toggle added for Full screen mode.	
Default value is False.	
*/
function toggleFullScreen(isFull) {
  var node = document.getElementById("shopify-section-1596642949266");
  console.log(node, "node");
  if (node) {
    var container = node.querySelector(".custome__iframe");
    console.log(container);
    if (container) {
      if (isFull === true) {
        container.style.maxWidth = "100%";
        container.style.height = "1020px";
      } else {
        container.style.maxWidth = "1090px";
        container.style.height = "780px";
      }
    }
  }
}

/**
 * Adds item to current cart object. Creates a new cart object if none exists.
 *
 * @param {Object} cart_item Object containing item data.
 */
function addToCart(cart_item) {
  request_data = JSON.stringify({
    items: [cart_item],
  });

  request_url = "/cart/add.js";

  makeApiCall(request_url, request_data, "post", (data) => {
    // Wait for new product images to load, before displaying cart
    setTimeout(() => {
      console.log("Redirecting to cart...", data);
      if (data && data.items && data.items.length > 0 && data.items[0].url) {
        window.location = `${data.items[0].url}&showCart=true`;
      } else {
        window.location = "/?showCart=true";
      }
    }, 3000);
  });
}

/**
 * Handles api calls.
 */
function makeApiCall(request_url, request_body, request_type, callback) {
  let req_content = {};

  req_headers = new Headers({
    "Content-Type": "application/json",
    Origin: "",
  });

  if (request_body != "") {
    request_data = {
      method: request_type,
      headers: req_headers,
      body: request_body,
    };
  } else {
    request_data = {
      method: request_type,
      headers: req_headers,
    };
  }

  fetch(request_url, request_data)
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      if (callback != null) {
        callback(data);
      }
    });
}
